import { CommonModule } from '@angular/common';
import { Component, HostListener, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/auth/services/auth.service';
import { AlertasService } from '../../features/alertas/services/alertas.service';
import { SidebarStateService } from '../sidebar/sidebar-state.service';

// De quanto em quanto tempo o sino reconsulta. Alerta nasce na importação de
// um extrato, que é ação de minutos, não de segundos - consultar mais que isso
// só geraria tráfego sem ninguém perceber a diferença.
const MillisAtualizacaoSino = 60_000;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header implements OnInit, OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  private readonly alertasService = inject(AlertasService);
  readonly sidebarState = inject(SidebarStateService);

  currentUser$ = this.authService.currentUser$;
  menuAberto = false;

  // Signal compartilhado com a tela de Alertas: marcar um alerta como lido lá
  // apaga o badge aqui na hora, sem esperar a próxima consulta.
  readonly alertasNaoLidos = this.alertasService.naoLidos;

  private intervaloSino: ReturnType<typeof setInterval> | null = null;

  ngOnInit(): void {
    this.atualizarAlertas();
    this.intervaloSino = setInterval(() => this.atualizarAlertas(), MillisAtualizacaoSino);
  }

  ngOnDestroy(): void {
    if (this.intervaloSino !== null) {
      clearInterval(this.intervaloSino);
    }
  }

  // Falha de rede aqui não pode quebrar a barra do topo: o erro fica no
  // console e o badge segue com o último número que deu certo.
  private atualizarAlertas(): void {
    this.alertasService.atualizarNaoLidos().subscribe({
      error: (erro) => console.error('Erro ao consultar os alertas não lidos:', erro),
    });
  }

  rotuloSino(): string {
    const total = this.alertasNaoLidos();
    if (total === 0) {
      return 'Alertas - nenhum alerta novo';
    }
    return total === 1 ? '1 alerta novo' : `${total} alertas novos`;
  }

  abrirAlertas(): void {
    this.menuAberto = false;
    this.router.navigate(['/alertas']);
  }

  getInitials(nome?: string | null): string {
    if (!nome) {
      return '?';
    }

    const partes = nome
      .trim()
      .split(' ')
      .filter(Boolean);

    if (partes.length === 0) {
      return '?';
    }

    if (partes.length === 1) {
      return partes[0].substring(0, 2).toUpperCase();
    }

    return `${partes[0][0]}${partes[partes.length - 1][0]}`.toUpperCase();
  }

  toggleMenu(event: MouseEvent): void {
    event.stopPropagation();
    this.menuAberto = !this.menuAberto;
  }


  gerenciarUsuarios(): void {
    this.menuAberto = false;
    this.router.navigate(['/usuarios']);
  }

  async sair(): Promise<void> {
    this.menuAberto = false;
    await this.authService.logout();
  }

  @HostListener('document:click')
  fecharMenu(): void {
    this.menuAberto = false;
  }
}